<template>
  <el-select
      class="tags-select"
      style="width: 100%"
      :disabled="disableOrNot"
      v-model="teacherLabel"
      multiple
      placeholder="请选择"
      ref="selectRefs"
      :placeholder="placeholder"
      fixed>
    <el-input
        style="width: 75%"
        placeholder="输入关键字搜索"
        v-model="filterText"
        @click.stop.native
        class="sel-input"
        v-if="teacherData.length !== 0">
    </el-input>
    <el-button @click="clearTreeSelect" type="primary" style="width: 20%">清除</el-button>
    <el-option v-model="teacherLabel" class="sel-option" style="width: 100%">
      <el-tree
          style="width: 100%"
          :data="teacherData"
          :props="teacherDataProps"
          :node-key="'id'"
          :default-checked-keys="existTeacherIds"
          :default-expanded-keys="existTeacherIds"
          show-checkbox
          :render-after-expand="false"
          accordion
          @check-change="handleCheckChange"
          :filter-node-method="filterNode"
          ref="teacherDataTree">
      </el-tree>
    </el-option>
  </el-select>
</template>

<script>

export default {
  name: 'TeacherTree',
  props: {
    disableOrNot: {
      type: Boolean
    },
    placeholder: {
      type: String,
      default: ''
    },
    teacherData: {
      type: Array,
      default: () => []
    },
    teacherDataProps: {
      type: Object,
      default: () => {
        return {
          id: 'id',
          label: 'label',
          children: 'children'
        }
      }
    },
    filterable: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    existTeacherIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      leafNodes: [],
      filterText: '',
      teacherLabel: [],
      localTeacherIds: [],
    }
  },
  watch: {
    filterText(val) {
      this.filterTree(val);
    },
    localTeacherIds: {
      handler(newval, oldval) {
        if (newval) {
          this.$emit('update:userIds', this.localTeacherIds);
        }
      },
    },
    existTeacherIds: {
      handler(newval, oldval) {
        if (newval && newval.length === 0){
          this.clearTreeSelect();
        }
      }
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    //节点选中状态发生变化时的回调
    handleCheckChange() {
      //获取所有选中的节点 start
      let res = this.$refs.teacherDataTree.getCheckedNodes();
      let teacherId = [];
      this.teacherLabel = [];
      res.forEach((item) => {
        if (item.isLeaf) {
          teacherId.push(item.id);
          this.teacherLabel.push(item.label);
        }
      });
      this.localTeacherIds = teacherId;
    },

    filterTree(keywords) {
      this.$refs.testDataTree.filter(keywords);
    },

    //获取叶子节点
    getLeafNodes(tree) {
      if (!tree) {
        return [];
      }
      const leafNodes = [];
      const queue = [];

      // 初始根节点入队
      queue.push(...tree);

      while (queue.length) {
        const node = queue.shift(); // 出队处理当前节点

        // 判断当前节点是否为叶子节点，并且 isLeaf 为 true
        if (node.isLeaf) {
          leafNodes.push(node); // 添加当前叶子节点到结果列表
        }

        if (node.children) {
          // 将当前节点的子节点入队
          queue.push(...node.children);
        }
      }
      return leafNodes;
    },

    //清除
    clearTreeSelect() {
      this.$refs.teacherDataTree.setCheckedKeys([]);
    }
  },
};
</script>

<style>
.sel-option {
  width: 300px;
  height: auto;
  max-height: 200px;
  overflow: auto;
  cursor: pointer;
  font-weight: normal !important;
  padding: 0 5px;
}

.sel-input {
  width: 300px;
  margin: 5px;
}
.sel-option .el-tag__close {
  display: none;
}
.el-select__tags {
  flex-wrap: nowrap;
  overflow: hidden;
}

.tags-select .el-tag__close.el-icon-close {
  display: none;
}
</style>
